import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Users, Layers, Shield } from 'lucide-react';

const NAV_ITEMS = [
  { path: '/admin',       label: 'Clients',       icon: Users },
  { path: '/admin/build', label: 'Build Tracker',  icon: Layers },
];

const AdminNav = () => {
  const { pathname } = useLocation();

  const isActive = (path) => {
    if (path === '/admin') return pathname === '/admin';
    return pathname.startsWith(path);
  };

  return (
    <nav className="flex items-center gap-1 bg-[#18181B] border border-[#F0EFF4]/10 rounded-xl px-2 py-1.5 mb-6">
      <Shield className="w-4 h-4 text-[#7B61FF] mr-2 shrink-0" />
      <span className="text-xs text-[#F0EFF4]/40 uppercase tracking-wider font-data mr-3 hidden sm:inline">Admin</span>
      {NAV_ITEMS.map(({ path, label, icon: Icon }) => (
        <Link
          key={path}
          to={path}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all
            ${isActive(path)
              ? 'bg-[#7B61FF]/20 text-[#7B61FF] ring-1 ring-[#7B61FF]/30'
              : 'text-[#F0EFF4]/50 hover:text-[#F0EFF4]/80 hover:bg-[#F0EFF4]/5'
            }`}
        >
          <Icon className="w-3.5 h-3.5" />
          {label}
        </Link>
      ))}
    </nav>
  );
};

export default AdminNav;
